export interface ITasksState {
    getTasksDetails : any;
    getTasksSuccessMessage : any;
    getTasksErrorMessage : any;
    getAddTaskForSubUserSuccess: any;
    getAddTaskForSubUserError: any;
}

export const initialTasksState : ITasksState =  {
    getTasksDetails : null,
    getTasksSuccessMessage : null,
    getTasksErrorMessage : null,
    getAddTaskForSubUserSuccess: null,
    getAddTaskForSubUserError: null,
}